let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k7UyM")).then(() => parcelRequire('4xEVz'));